module.exports = __webpack_public_path__ + "a6a1dd3c74e5a55c823b7d81478db247.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/varsovia.png
// module id = 630
// module chunks = 0